import { getPath } from '@/router/common'

const baseUrl = {
  title: '重量体积计算器',
  path: 'Calculator'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'CalculatorIndex',
    component: () => import('@/views/calculator/index/index.vue'),
    meta: {
      title: '重量体积计算器'
    }
  },
  {
    path: getPath('Details', baseUrl),
    name: 'CalculatorDetails',
    component: () => import(/* webpackChunkName: "Details" */ '@/views/calculator/details/index.vue'),
    meta: {
      title: '重量体积规格'
    }
  }
]
